import { render, staticRenderFns } from "./teikiCartContainer.vue?vue&type=template&id=564649e6&"
import script from "./teikiCartContainer.vue?vue&type=script&lang=js&"
export * from "./teikiCartContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports